/* Purpose FX: live laser streaks + interactive chrome wordmark.
   Lasers: canvas.lasers inside a .hero, data-lasers="left,right" (red|blue|green).
   Wordmark: #wm-tilt inside the hero gets cursor tilt + spotlight. */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ================= Lasers ================= */

  var PAL = {
    red:   { deep: [205, 30, 26],  main: [255, 64, 56],  hot: [255, 196, 188] },
    blue:  { deep: [0, 90, 190],   main: [0, 150, 221],  hot: [165, 228, 255] },
    green: { deep: [16, 140, 90],  main: [46, 204, 113], hot: [180, 255, 216] }
  };

  function rgba(c, a) { return 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + a + ')'; }

  /* A bundle is a cohesive comb of filaments around one spine:
     wide fan at the screen edge, converging waist, taper at the tip. */
  function buildBundle(side, pal, W, H, count, opt) {
    var fil = [];
    for (var i = 0; i < count; i++) {
      var e = count > 1 ? (i / (count - 1)) * 2 - 1 : 0;
      var jit = (Math.random() - 0.5) * 0.03;
      var yE = H * (opt.yEdge + e * opt.spreadEdge + jit);
      var yT = H * (opt.yTip + e * opt.spreadTip + jit * 0.4);
      var reach = opt.tipX - Math.abs(e) * opt.tipTaper - Math.random() * 0.04;
      fil.push({
        yE: yE,
        yT: yT,
        xT: side < 0 ? W * reach : W * (1 - reach),
        dip: H * opt.dip * (1 - Math.abs(e) * 0.35),
        w: 0.6 + Math.random() * 1.5 + (1 - Math.abs(e)) * 0.8,
        amp: H * (0.006 + Math.random() * 0.012),
        speed: 0.3 + Math.random() * 0.5,
        phase: Math.random() * 6.2832,
        dashLen: H * (0.16 + Math.random() * 0.2),
        dashSpeed: 110 + Math.random() * 170,
        core: i % Math.max(2, Math.round(count / 7)) === 0,
        alpha: (0.5 + Math.random() * 0.5) * (1 - Math.abs(e) * 0.35) * opt.gain
      });
    }
    return { side: side, pal: pal, x0: side < 0 ? -W * 0.05 : W * 1.05, W: W, fil: fil };
  }

  function setupLasers(canvas) {
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    var names = (canvas.getAttribute('data-lasers') || 'red,blue').split(',');
    var bundles = [], W = 0, H = 0, visible = true;

    function size() {
      W = canvas.offsetWidth;
      H = canvas.offsetHeight;
      canvas.width = W * dpr;
      canvas.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var m = W < 760;
      bundles = [];
      for (var s = 0; s < 2; s++) {
        var pal = PAL[names[s]] || PAL.blue;
        if (!names[s]) continue;
        var side = s === 0 ? -1 : 1;
        /* main river: wide at the edge, converges toward the center third */
        bundles.push(buildBundle(side, pal, W, H, m ? 14 : 24, {
          yEdge: 0.56, spreadEdge: 0.30, yTip: 0.45, spreadTip: 0.055,
          tipX: m ? 0.52 : 0.46, tipTaper: 0.14, dip: 0.085, gain: 1
        }));
        /* corner flare: red dives to the bottom corner, blue climbs to the top */
        bundles.push(buildBundle(side, pal, W, H, m ? 5 : 8, {
          yEdge: side < 0 ? 0.86 : 0.16, spreadEdge: 0.10,
          yTip: side < 0 ? 1.12 : -0.12, spreadTip: 0.05,
          tipX: 0.30, tipTaper: 0.08, dip: side < 0 ? 0.05 : -0.05, gain: 0.55
        }));
      }
    }

    function strokeFil(b, f, t, width, colorStops, dashed) {
      var sw1 = Math.sin(t * f.speed + f.phase) * f.amp;
      var sw2 = Math.sin(t * f.speed * 0.8 + f.phase + 1.7) * f.amp * 1.5;
      var sw3 = Math.sin(t * f.speed * 0.6 + f.phase + 3.1) * f.amp;
      var g = ctx.createLinearGradient(b.x0, 0, f.xT, 0);
      for (var i = 0; i < colorStops.length; i++) g.addColorStop(colorStops[i][0], colorStops[i][1]);
      ctx.strokeStyle = g;
      ctx.lineWidth = width;
      ctx.lineCap = 'round';
      if (dashed) {
        ctx.setLineDash([f.dashLen, f.dashLen * 2.2]);
        ctx.lineDashOffset = -(t * f.dashSpeed + f.phase * 60);
      }
      var c1x = b.x0 + (f.xT - b.x0) * 0.32;
      var c2x = b.x0 + (f.xT - b.x0) * 0.68;
      ctx.beginPath();
      ctx.moveTo(b.x0, f.yE);
      ctx.bezierCurveTo(
        c1x, f.yE + f.dip + sw1,
        c2x, f.yT + f.dip * 0.25 + sw2,
        f.xT, f.yT + sw3
      );
      ctx.stroke();
      if (dashed) ctx.setLineDash([]);
    }

    function frame(t) {
      ctx.clearRect(0, 0, W, H);
      ctx.globalCompositeOperation = 'lighter';
      for (var b = 0; b < bundles.length; b++) {
        var bun = bundles[b], pal = bun.pal;
        for (var i = 0; i < bun.fil.length; i++) {
          var f = bun.fil[i];
          var pulse = 0.85 + 0.15 * Math.sin(t * 0.7 + f.phase * 2);
          var a = f.alpha * pulse;
          /* ambient glow */
          strokeFil(bun, f, t, f.w * 10, [
            [0, rgba(pal.deep, 0.05 * a)], [0.5, rgba(pal.main, 0.06 * a)], [1, rgba(pal.main, 0)]
          ], false);
          /* body */
          strokeFil(bun, f, t, f.w * 3.4, [
            [0, rgba(pal.deep, 0.28 * a)], [0.45, rgba(pal.main, 0.3 * a)], [0.9, rgba(pal.main, 0.08 * a)], [1, rgba(pal.main, 0)]
          ], false);
          /* bright ribbon */
          strokeFil(bun, f, t, f.w * 1.2, [
            [0, rgba(pal.hot, 0.5 * a)], [0.4, rgba(pal.hot, 0.62 * a)], [0.85, rgba(pal.main, 0.16 * a)], [1, rgba(pal.main, 0)]
          ], false);
          /* white-hot core with traveling glints */
          if (f.core) {
            strokeFil(bun, f, t, Math.max(0.9, f.w * 0.5), [
              [0, 'rgba(255,255,255,' + (0.75 * a) + ')'], [0.55, 'rgba(255,255,255,' + (0.85 * a) + ')'], [1, 'rgba(255,255,255,0)']
            ], !reduced);
          }
        }
      }
      ctx.globalCompositeOperation = 'source-over';
    }

    size();
    canvas.classList.add('on');

    if (reduced) { frame(1.7); addEventListener('resize', function () { size(); frame(1.7); }); return; }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(canvas);
    }
    function loop(now) {
      if (visible && !document.hidden) frame(now / 1000);
      requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);
    addEventListener('resize', size);
  }

  var canvases = document.querySelectorAll('canvas.lasers');
  for (var i = 0; i < canvases.length; i++) setupLasers(canvases[i]);

  /* ================= Wordmark ================= */

  var tilt = document.getElementById('wm-tilt');
  if (tilt && !reduced && window.matchMedia('(hover: hover)').matches) {
    var hero = tilt.closest('.hero') || tilt.parentElement;
    var spot = tilt.querySelector('.wm-spot');
    hero.addEventListener('mousemove', function (e) {
      var r = tilt.getBoundingClientRect();
      if (!r.width) return;
      var px = (e.clientX - r.left) / r.width;
      var py = (e.clientY - r.top) / r.height;
      tilt.style.setProperty('--wm-x', (px * 100).toFixed(1) + '%');
      tilt.style.setProperty('--wm-y', (py * 100).toFixed(1) + '%');
      var cx = Math.max(-0.6, Math.min(0.6, px - 0.5));
      var cy = Math.max(-0.9, Math.min(0.9, py - 0.5));
      tilt.style.transform = 'perspective(900px) rotateX(' + (-cy * 4).toFixed(2) + 'deg) rotateY(' + (cx * 7).toFixed(2) + 'deg)';
      if (spot) spot.style.opacity = 1;
    });
    hero.addEventListener('mouseleave', function () {
      tilt.style.transform = 'perspective(900px) rotateX(0deg) rotateY(0deg)';
      if (spot) spot.style.opacity = 0;
    });
  }
})();
